// extracted by mini-css-extract-plugin
export default {"accordeonItem":"ProductDescription_accordeonItem__Eqgjg","accordionHeader":"ProductDescription_accordionHeader__TdXSI","collapsed":"ProductDescription_collapsed__whbZQ"};